import { SET_CLOSE_PROGRESS_AND_FRESH } from "./types";
export default {
  [SET_CLOSE_PROGRESS_AND_FRESH]: ({ state }) => {
    state.export_progressing.forEach((progress) => progress.remove(true));
    state.export_progressing = [];
  },
};
